import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const fortinet = defineConnector({
  identifier: "fortinet",
  name: "Fortinet",
  tagLine: "Network security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create a REST API administrator",
      items: [
        {
          kind: "markdown",
          content:
            "In your FortiGate console, go to **System > Administrators** and create a new **REST API Admin**. Assign the appropriate admin profile and trusted hosts. An API token will be generated automatically.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "FortiGate host",
          required: true,
          placeholder: "fortigate.example.com",
          helperText: "Your FortiGate hostname or IP address.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v2/monitor/system/status`,
  },
});
